var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeySidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General / Keys"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8.99891C10.0002 7.94998 10.3303 6.9277 10.9436 6.07673C11.5568 5.22576 12.4222 4.5892 13.4172 4.25715C14.4121 3.92509 15.4864 3.91436 16.4878 4.22647C17.4892 4.53858 18.3671 5.15772 18.9972 5.99627C19.6273 6.83482 19.9778 7.85031 19.999 8.89902C20.0202 9.94772 19.711 10.9765 19.1152 11.8398C18.5195 12.7032 17.6673 13.3573 16.6793 13.7095C15.6913 14.0618 14.6176 14.0945 13.61 13.8029L11.707 15.7059C11.5195 15.8935 11.2652 15.9988 11 15.9989H10V16.9989C10 17.2641 9.89464 17.5185 9.70711 17.706C9.51957 17.8935 9.26522 17.9989 9 17.9989H8V18.9989C8 19.2641 7.89464 19.5185 7.70711 19.706C7.51957 19.8935 7.26522 19.9989 7 19.9989H5C4.73478 19.9989 4.48043 19.8935 4.29289 19.706C4.10536 19.5185 4 19.2641 4 18.9989V16.9989C4.00006 16.7337 4.10545 16.4794 4.293 16.2919L10.196 10.3889C10.0657 9.93709 9.99967 9.46915 10 8.99891ZM15 5.99891C14.8011 5.99891 14.6103 6.07792 14.4697 6.21858C14.329 6.35923 14.25 6.54999 14.25 6.74891C14.25 6.94782 14.329 7.13858 14.4697 7.27924C14.6103 7.41989 14.8011 7.49891 15 7.49891C15.3978 7.49891 15.7794 7.65694 16.0607 7.93825C16.342 8.21955 16.5 8.60108 16.5 8.99891C16.5 9.19782 16.579 9.38858 16.7197 9.52924C16.8603 9.66989 17.0511 9.74891 17.25 9.74891C17.4489 9.74891 17.6397 9.66989 17.7803 9.52924C17.921 9.38858 18 9.19782 18 8.99891C18 8.20326 17.6839 7.44019 17.1213 6.87759C16.5587 6.31498 15.7956 5.99891 15 5.99891Z",
    fill: "#152946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeySidebar);
export default __webpack_public_path__ + "static/media/key-sidebar.209a778993cdb1a4ec05c2603ed3364e.svg";
export { ForwardRef as ReactComponent };